import { Page } from "../utils/page";
import Splide from '@splidejs/splide';

@Page()
class Blog {

  constructor() {

  }


	init() {
		this.hideLoader()
    this.fbShare()
    this.initCarousel()
    this.initLinks()

	}


	hideLoader() {
		const loader = (document.getElementById('loader') as HTMLElement).classList
		loader.add('hideLoader')
		setTimeout(() => loader.add('hide'), 1000)
	}

  fbShare(){
		var fbButton = document.getElementById('fb-share-button');
		var url = window.location.href;

		fbButton.addEventListener('click', function() {
			window.open('https://www.facebook.com/sharer/sharer.php?u=' + url,
				'facebook-share-dialog',
				'width=800,height=600'
			);

		});
	}
  initCarousel(){
		new Splide( '#blogSplide',
		{
			type: 'slide',
			drag: false,
			perPage: 3,
			arrows: false,
			width: '90%',
			autoplay: false,
			pagination: false,
			gap: '2em',
			breakpoints:{
				769: {
					perPage: 1,
					type: 'loop',
					width: '100%',
					drag: true,
					autoplay: true,
					interval: 2500,
					arrows: false,
				}
			},
		}).mount();
	}

  initLinks(){
		const content = document.querySelector('.blog-content')

		content.querySelectorAll('a').forEach((item)=>{

			item.target = '_blank'
		})
	}

}

const blog = new Blog()
